import { useFilters } from '@hooks/data/useFilters';
import { calculateFilterSpec } from '@routes/catalog/utils/calculateAvailableFilter';
import { useSessions } from '@fe-learner-common/hooks/data/useSessions';
import { useMemo } from 'react';

export const useAvailableFilters = () => {
  const { data: filterCategories } = useFilters({ enabled: true });
  const { data: sessionResponse } = useSessions({ enabled: true });

  const allowedFilterSet = useMemo(
    () =>
      new Set<string>(
        filterCategories?.filters.map((filter) => filter.name) || [],
      ),
    [filterCategories],
  );

  return useMemo(
    () =>
      calculateFilterSpec({
        list: sessionResponse?.sessions,
        allowedSet: allowedFilterSet,
      }),
    [sessionResponse, allowedFilterSet],
  );
};
